document.addEventListener('DOMContentLoaded', function() {
  function convertVideoLinksToEmbeds() {
    const rteElements = document.querySelectorAll('.rte');
    
    rteElements.forEach(function(rteElement) {
      const videoLinks = rteElement.querySelectorAll('a[href*="youtu.be"], a[href*="youtube.com"]');
      
      videoLinks.forEach(function(link) {
        const videoText = link.textContent.trim();
        const videoUrl = link.getAttribute('href');
        
        if (link.previousElementSibling && 
            link.previousElementSibling.tagName === 'STRONG' && 
            link.previousElementSibling.textContent.includes('🎥 Video:')) {
          
          const videoId = extractVideoId(videoUrl);
          if (videoId) {
            const embedContainer = createVideoEmbed(videoId, videoText);
            
            const paragraph = link.parentNode;
            paragraph.appendChild(embedContainer);
            
            link.previousElementSibling.remove();
            link.remove();
          }
        }
      });
    });
  }
  
  function extractVideoId(url) {
    const patterns = [
      /youtu\.be\/([a-zA-Z0-9_-]+)/,
      /youtube\.com\/watch\?v=([a-zA-Z0-9_-]+)/,
      /youtube\.com\/embed\/([a-zA-Z0-9_-]+)/
    ];
    
    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        return match[1];
      }
    }
    return null;
  }
  
  function createVideoEmbed(videoId, title) {
    const embedContainer = document.createElement('div');
    embedContainer.className = 'video-embed-container';
    embedContainer.style.cssText = `
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      margin: 20px 0;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    `;
    
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube.com/embed/${videoId}?rel=0&modestbranding=1`;
    iframe.title = title || 'Video';
    iframe.frameBorder = '0';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    `;
    
    embedContainer.appendChild(iframe);
    return embedContainer;
  }
  
  convertVideoLinksToEmbeds();
});